import { useState } from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { useSelector } from "react-redux";
import DriverEarning from './DriverEarning';
import { useParams } from 'react-router-dom';
import Earningreports from './Earningreports';
import { useTranslation } from "react-i18next";
import { fetchEarningsReportProps } from 'common/src/actions/earningreportsaction';
import { FormControl, InputLabel, Select, MenuItem, Grid, Paper } from '@mui/material';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AllReports() {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const auth = useSelector((state) => state.auth);
  const { fleetAdminId, fleetAdminName } = useParams();
  const [period, setPeriod] = useState<fetchEarningsReportProps['period']>('monthly');

  if (!auth.profile) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ p: 2, borderRadius: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Tabs
              value={value}
              aria-label="tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              {(auth.profile.usertype === "fleetadmin" || auth.profile.usertype === "admin" || fleetAdminId) &&
                <Tab style={{ marginRight: "20px" }} label={t('driver_earning')} {...a11yProps(0)} />
              }
              {(auth.profile.usertype === "admin" && !fleetAdminId) &&
                <Tab style={{ marginRight: "20px" }} label={t('earning_reports')} {...a11yProps(1)} />
              }
            </Tabs>
          </Grid>
          <Grid item>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>{t('period')}</InputLabel>
              <Select
                value={period}
                label={t('period')}
                onChange={(e) => setPeriod(e.target.value as any)}
              >
                <MenuItem value="daily">{t('daily')}</MenuItem>
                <MenuItem value="weekly">{t('weekly')}</MenuItem>
                <MenuItem value="monthly">{t('monthly')}</MenuItem>
                <MenuItem value="yearly">{t('yearly')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={value} index={0}>
        <DriverEarning period={period} fleetAdminId={fleetAdminId} fleetAdminName={fleetAdminName} />
      </TabPanel>

      {auth.profile.usertype === "admin" && !fleetAdminId && (
        <TabPanel value={value} index={1}>
          <Earningreports period={period} />
        </TabPanel>
      )}
    </Box>
  );
}